export default [
  {
    icon: 'home',
    title: 'Home',
    to: '/',
    auth: true
  },
  {
    icon: 'book',
    title: 'Ged',
    to: '/ged',
    auth: true
  },
  {
    icon: 'book',
    title: 'Usuários',
    to: '/usuarios',
    auth: true
  },
  {
    icon: 'lock',
    title: 'Login',
    to: '/login',
    auth: false
  },
  {
    icon: 'lock_open',
    title: 'Sair',
    to: '/logout',
    auth: true
  }]
